<template>
  <select class="form-control" v-model="cityId" v-on:change="onInput">
    <option value="">市区町村を選択してください。</option>
    <option v-for="prefecture in cities"
            :value="prefecture.city_id">
      {{prefecture.city_name}}
    </option>
  </select>
</template>
<script>
  import Api from '@/service/Api.vue'

  export default {
    props: [
      'prefecture_id',
      'val'
    ],
    data () {
      return {
        cities: [],
        cityId: ''
      }
    },
    watch: {
      'prefecture_id' (to, from) {
        this.initCity()
      }
    },
    created: function () {
      this.cityId = this.val
      Api.city.prefecture(this.prefecture_id).then(this.successPrefecture1)
    },
    methods: {
      initCity: function () {
        if (this.prefecture_id) {
          Api.city.prefecture(this.prefecture_id).then(this.successPrefecture2)
        }
      },
      // 初期化用
      successPrefecture1: function (result) {
        this.cities = result.data.cities
      },
      // 選択し変えた用
      successPrefecture2: function (result) {
        this.cities = result.data.cities
        var cityId = this.cityId
        var check = false
        if (this.cities.length) {
          this.cities.forEach(function (city) {
            if (city.city_id === cityId) {
              check = true
            }
          })
        }
        if (!check) {
          this.cityId = ''
        }
      },
      onInput (e) {
        var id = e.target.value
        var cityName = ''
        this.cities.forEach(function (val) {
          if (val.city_id === Number(id)) {
            cityName = val.city_name
          }
        })

        this.$emit('display', cityName)
        this.$emit('input', e.target.value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectCity.vue?4ff8daaf